import { render, staticRenderFns } from "./ContentPart.vue?vue&type=template&id=71557e03&"
import script from "./ContentPart.vue?vue&type=script&lang=ts&"
export * from "./ContentPart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@5.2.7_vue-template-compiler@2.6.11_webpack@5.75.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports